import React from "react";

export const QRCodeSvg = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_40008726_10210)">
        <path d="M64 0H0V64H64V0Z" fill="white" />
        <path d="M5.93103 4H4V5.93103H5.93103V4Z" fill="#2A2A2A" />
        <path d="M7.86207 4H5.93103V5.93103H7.86207V4Z" fill="#2A2A2A" />
        <path d="M9.7931 4H7.86207V5.93103H9.7931V4Z" fill="#2A2A2A" />
        <path d="M11.7241 4H9.7931V5.93103H11.7241V4Z" fill="#2A2A2A" />
        <path d="M13.6552 4H11.7241V5.93103H13.6552V4Z" fill="#2A2A2A" />
        <path d="M15.5862 4H13.6552V5.93103H15.5862V4Z" fill="#2A2A2A" />
        <path d="M17.5172 4H15.5862V5.93103H17.5172V4Z" fill="#2A2A2A" />
        <path d="M23.3103 4H21.3793V5.93103H23.3103V4Z" fill="#2A2A2A" />
        <path d="M27.1724 4H25.2414V5.93103H27.1724V4Z" fill="#2A2A2A" />
        <path d="M32.9655 4H31.0345V5.93103H32.9655V4Z" fill="#2A2A2A" />
        <path d="M36.8276 4H34.8966V5.93103H36.8276V4Z" fill="#2A2A2A" />
        <path d="M40.6897 4H38.7586V5.93103H40.6897V4Z" fill="#2A2A2A" />
        <path d="M44.5517 4H42.6207V5.93103H44.5517V4Z" fill="#2A2A2A" />
        <path d="M48.4138 4H46.4828V5.93103H48.4138V4Z" fill="#2A2A2A" />
        <path d="M50.3448 4H48.4138V5.93103H50.3448V4Z" fill="#2A2A2A" />
        <path d="M52.2759 4H50.3448V5.93103H52.2759V4Z" fill="#2A2A2A" />
        <path d="M54.2069 4H52.2759V5.93103H54.2069V4Z" fill="#2A2A2A" />
        <path d="M56.1379 4H54.2069V5.93103H56.1379V4Z" fill="#2A2A2A" />
        <path d="M58.069 4H56.1379V5.93103H58.069V4Z" fill="#2A2A2A" />
        <path d="M60 4H58.069V5.93103H60V4Z" fill="#2A2A2A" />
        <path d="M5.93103 5.93103H4V7.86207H5.93103V5.93103Z" fill="#2A2A2A" />
        <path
          d="M17.5172 5.93103H15.5862V7.86207H17.5172V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 5.93103H19.4483V7.86207H21.3793V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 5.93103H21.3793V7.86207H23.3103V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 5.93103H23.3103V7.86207H25.2414V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 5.93103H27.1724V7.86207H29.1034V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 5.93103H31.0345V7.86207H32.9655V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 5.93103H32.9655V7.86207H34.8966V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 5.93103H36.8276V7.86207H38.7586V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 5.93103H38.7586V7.86207H40.6897V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 5.93103H42.6207V7.86207H44.5517V5.93103Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 5.93103H46.4828V7.86207H48.4138V5.93103Z"
          fill="#2A2A2A"
        />
        <path d="M60 5.93103H58.069V7.86207H60V5.93103Z" fill="#2A2A2A" />
        <path d="M5.93103 7.86207H4V9.7931H5.93103V7.86207Z" fill="#2A2A2A" />
        <path
          d="M9.7931 7.86207H7.86207V9.7931H9.7931V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 7.86207H9.7931V9.7931H11.7241V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 7.86207H11.7241V9.7931H13.6552V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 7.86207H15.5862V9.7931H17.5172V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 7.86207H19.4483V9.7931H21.3793V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 7.86207H27.1724V9.7931H29.1034V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 7.86207H29.1034V9.7931H31.0345V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 7.86207H32.9655V9.7931H34.8966V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 7.86207H34.8966V9.7931H36.8276V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 7.86207H36.8276V9.7931H38.7586V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 7.86207H38.7586V9.7931H40.6897V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 7.86207H40.6897V9.7931H42.6207V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 7.86207H46.4828V9.7931H48.4138V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 7.86207H50.3448V9.7931H52.2759V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 7.86207H52.2759V9.7931H54.2069V7.86207Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 7.86207H54.2069V9.7931H56.1379V7.86207Z"
          fill="#2A2A2A"
        />
        <path d="M60 7.86207H58.069V9.7931H60V7.86207Z" fill="#2A2A2A" />
        <path d="M5.93103 9.7931H4V11.7241H5.93103V9.7931Z" fill="#2A2A2A" />
        <path
          d="M9.7931 9.7931H7.86207V11.7241H9.7931V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 9.7931H9.7931V11.7241H11.7241V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 9.7931H11.7241V11.7241H13.6552V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 9.7931H15.5862V11.7241H17.5172V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 9.7931H21.3793V11.7241H23.3103V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 9.7931H27.1724V11.7241H29.1034V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 9.7931H32.9655V11.7241H34.8966V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 9.7931H40.6897V11.7241H42.6207V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 9.7931H42.6207V11.7241H44.5517V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 9.7931H46.4828V11.7241H48.4138V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 9.7931H50.3448V11.7241H52.2759V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 9.7931H52.2759V11.7241H54.2069V9.7931Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 9.7931H54.2069V11.7241H56.1379V9.7931Z"
          fill="#2A2A2A"
        />
        <path d="M60 9.7931H58.069V11.7241H60V9.7931Z" fill="#2A2A2A" />
        <path d="M5.93103 11.7241H4V13.6552H5.93103V11.7241Z" fill="#2A2A2A" />
        <path
          d="M9.7931 11.7241H7.86207V13.6552H9.7931V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 11.7241H9.7931V13.6552H11.7241V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 11.7241H11.7241V13.6552H13.6552V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 11.7241H15.5862V13.6552H17.5172V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 11.7241H21.3793V13.6552H23.3103V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 11.7241H23.3103V13.6552H25.2414V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 11.7241H27.1724V13.6552H29.1034V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 11.7241H31.0345V13.6552H32.9655V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 11.7241H36.8276V13.6552H38.7586V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 11.7241H42.6207V13.6552H44.5517V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 11.7241H46.4828V13.6552H48.4138V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 11.7241H50.3448V13.6552H52.2759V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 11.7241H52.2759V13.6552H54.2069V11.7241Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 11.7241H54.2069V13.6552H56.1379V11.7241Z"
          fill="#2A2A2A"
        />
        <path d="M60 11.7241H58.069V13.6552H60V11.7241Z" fill="#2A2A2A" />
        <path d="M5.93103 13.6552H4V15.5862H5.93103V13.6552Z" fill="#2A2A2A" />
        <path
          d="M17.5172 13.6552H15.5862V15.5862H17.5172V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 13.6552H23.3103V15.5862H25.2414V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 13.6552H25.2414V15.5862H27.1724V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 13.6552H27.1724V15.5862H29.1034V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 13.6552H32.9655V15.5862H34.8966V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 13.6552H36.8276V15.5862H38.7586V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 13.6552H40.6897V15.5862H42.6207V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 13.6552H42.6207V15.5862H44.5517V13.6552Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 13.6552H46.4828V15.5862H48.4138V13.6552Z"
          fill="#2A2A2A"
        />
        <path d="M60 13.6552H58.069V15.5862H60V13.6552Z" fill="#2A2A2A" />
        <path d="M5.93103 15.5862H4V17.5172H5.93103V15.5862Z" fill="#2A2A2A" />
        <path
          d="M7.86207 15.5862H5.93103V17.5172H7.86207V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M9.7931 15.5862H7.86207V17.5172H9.7931V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 15.5862H9.7931V17.5172H11.7241V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 15.5862H11.7241V17.5172H13.6552V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 15.5862H13.6552V17.5172H15.5862V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 15.5862H15.5862V17.5172H17.5172V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 15.5862H19.4483V17.5172H21.3793V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 15.5862H23.3103V17.5172H25.2414V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 15.5862H27.1724V17.5172H29.1034V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 15.5862H31.0345V17.5172H32.9655V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 15.5862H34.8966V17.5172H36.8276V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 15.5862H38.7586V17.5172H40.6897V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 15.5862H42.6207V17.5172H44.5517V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 15.5862H46.4828V17.5172H48.4138V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 15.5862H48.4138V17.5172H50.3448V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 15.5862H50.3448V17.5172H52.2759V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 15.5862H52.2759V17.5172H54.2069V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 15.5862H54.2069V17.5172H56.1379V15.5862Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 15.5862H56.1379V17.5172H58.069V15.5862Z"
          fill="#2A2A2A"
        />
        <path d="M60 15.5862H58.069V17.5172H60V15.5862Z" fill="#2A2A2A" />
        <path
          d="M23.3103 17.5172H21.3793V19.4483H23.3103V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 17.5172H23.3103V19.4483H25.2414V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 17.5172H25.2414V19.4483H27.1724V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 17.5172H29.1034V19.4483H31.0345V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 17.5172H31.0345V19.4483H32.9655V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 17.5172H32.9655V19.4483H34.8966V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 17.5172H34.8966V19.4483H36.8276V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 17.5172H36.8276V19.4483H38.7586V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 17.5172H42.6207V19.4483H44.5517V17.5172Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 19.4483H9.7931V21.3793H11.7241V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 19.4483H13.6552V21.3793H15.5862V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 19.4483H15.5862V21.3793H17.5172V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M19.4483 19.4483H17.5172V21.3793H19.4483V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 19.4483H21.3793V21.3793H23.3103V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 19.4483H23.3103V21.3793H25.2414V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 19.4483H25.2414V21.3793H27.1724V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 19.4483H29.1034V21.3793H31.0345V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 19.4483H32.9655V21.3793H34.8966V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 19.4483H34.8966V21.3793H36.8276V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 19.4483H36.8276V21.3793H38.7586V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 19.4483H44.5517V21.3793H46.4828V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 19.4483H54.2069V21.3793H56.1379V19.4483Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 19.4483H56.1379V21.3793H58.069V19.4483Z"
          fill="#2A2A2A"
        />
        <path d="M5.93103 21.3793H4V23.3103H5.93103V21.3793Z" fill="#2A2A2A" />
        <path
          d="M13.6552 21.3793H11.7241V23.3103H13.6552V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 21.3793H13.6552V23.3103H15.5862V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M19.4483 21.3793H17.5172V23.3103H19.4483V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 21.3793H19.4483V23.3103H21.3793V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 21.3793H25.2414V23.3103H27.1724V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 21.3793H29.1034V23.3103H31.0345V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 21.3793H32.9655V23.3103H34.8966V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 21.3793H38.7586V23.3103H40.6897V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 21.3793H40.6897V23.3103H42.6207V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 21.3793H42.6207V23.3103H44.5517V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 21.3793H44.5517V23.3103H46.4828V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 21.3793H46.4828V23.3103H48.4138V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 21.3793H48.4138V23.3103H50.3448V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 21.3793H50.3448V23.3103H52.2759V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 21.3793H54.2069V23.3103H56.1379V21.3793Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 21.3793H56.1379V23.3103H58.069V21.3793Z"
          fill="#2A2A2A"
        />
        <path d="M60 21.3793H58.069V23.3103H60V21.3793Z" fill="#2A2A2A" />
        <path
          d="M7.86207 23.3103H5.93103V25.2414H7.86207V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 23.3103H11.7241V25.2414H13.6552V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 23.3103H13.6552V25.2414H15.5862V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 23.3103H15.5862V25.2414H17.5172V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M19.4483 23.3103H17.5172V25.2414H19.4483V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 23.3103H19.4483V25.2414H21.3793V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 23.3103H25.2414V25.2414H27.1724V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 23.3103H27.1724V25.2414H29.1034V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 23.3103H31.0345V25.2414H32.9655V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 23.3103H32.9655V25.2414H34.8966V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 23.3103H34.8966V25.2414H36.8276V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 23.3103H38.7586V25.2414H40.6897V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 23.3103H50.3448V25.2414H52.2759V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 23.3103H52.2759V25.2414H54.2069V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 23.3103H54.2069V25.2414H56.1379V23.3103Z"
          fill="#2A2A2A"
        />
        <path
          d="M7.86207 25.2414H5.93103V27.1724H7.86207V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M9.7931 25.2414H7.86207V27.1724H9.7931V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 25.2414H11.7241V27.1724H13.6552V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 25.2414H13.6552V27.1724H15.5862V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M19.4483 25.2414H17.5172V27.1724H19.4483V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 25.2414H19.4483V27.1724H21.3793V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 25.2414H21.3793V27.1724H23.3103V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 25.2414H23.3103V27.1724H25.2414V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 25.2414H29.1034V27.1724H31.0345V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 25.2414H31.0345V27.1724H32.9655V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 25.2414H34.8966V27.1724H36.8276V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 25.2414H40.6897V27.1724H42.6207V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 25.2414H42.6207V27.1724H44.5517V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 25.2414H44.5517V27.1724H46.4828V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 25.2414H48.4138V27.1724H50.3448V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 25.2414H50.3448V27.1724H52.2759V25.2414Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 25.2414H54.2069V27.1724H56.1379V25.2414Z"
          fill="#2A2A2A"
        />
        <path d="M60 25.2414H58.069V27.1724H60V25.2414Z" fill="#2A2A2A" />
        <path d="M5.93103 27.1724H4V29.1034H5.93103V27.1724Z" fill="#2A2A2A" />
        <path
          d="M9.7931 27.1724H7.86207V29.1034H9.7931V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 27.1724H9.7931V29.1034H11.7241V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 27.1724H13.6552V29.1034H15.5862V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 27.1724H15.5862V29.1034H17.5172V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 27.1724H21.3793V29.1034H23.3103V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 27.1724H25.2414V29.1034H27.1724V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 27.1724H29.1034V29.1034H31.0345V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 27.1724H31.0345V29.1034H32.9655V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 27.1724H36.8276V29.1034H38.7586V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 27.1724H38.7586V29.1034H40.6897V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 27.1724H40.6897V29.1034H42.6207V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 27.1724H44.5517V29.1034H46.4828V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 27.1724H48.4138V29.1034H50.3448V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 27.1724H54.2069V29.1034H56.1379V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 27.1724H56.1379V29.1034H58.069V27.1724Z"
          fill="#2A2A2A"
        />
        <path
          d="M7.86207 29.1034H5.93103V31.0345H7.86207V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 29.1034H9.7931V31.0345H11.7241V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M19.4483 29.1034H17.5172V31.0345H19.4483V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 29.1034H27.1724V31.0345H29.1034V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 29.1034H29.1034V31.0345H31.0345V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 29.1034H36.8276V31.0345H38.7586V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 29.1034H42.6207V31.0345H44.5517V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 29.1034H52.2759V31.0345H54.2069V29.1034Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 29.1034H54.2069V31.0345H56.1379V29.1034Z"
          fill="#2A2A2A"
        />
        <path d="M60 29.1034H58.069V31.0345H60V29.1034Z" fill="#2A2A2A" />
        <path d="M5.93103 31.0345H4V32.9655H5.93103V31.0345Z" fill="#2A2A2A" />
        <path
          d="M7.86207 31.0345H5.93103V32.9655H7.86207V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 31.0345H13.6552V32.9655H15.5862V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 31.0345H15.5862V32.9655H17.5172V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 31.0345H21.3793V32.9655H23.3103V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 31.0345H29.1034V32.9655H31.0345V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 31.0345H34.8966V32.9655H36.8276V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 31.0345H36.8276V32.9655H38.7586V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 31.0345H40.6897V32.9655H42.6207V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 31.0345H42.6207V32.9655H44.5517V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 31.0345H54.2069V32.9655H56.1379V31.0345Z"
          fill="#2A2A2A"
        />
        <path
          d="M9.7931 32.9655H7.86207V34.8966H9.7931V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 32.9655H9.7931V34.8966H11.7241V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 32.9655H13.6552V34.8966H15.5862V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 32.9655H19.4483V34.8966H21.3793V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 32.9655H31.0345V34.8966H32.9655V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 32.9655H34.8966V34.8966H36.8276V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 32.9655H40.6897V34.8966H42.6207V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 32.9655H44.5517V34.8966H46.4828V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 32.9655H46.4828V34.8966H48.4138V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 32.9655H48.4138V34.8966H50.3448V32.9655Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 32.9655H54.2069V34.8966H56.1379V32.9655Z"
          fill="#2A2A2A"
        />
        <path d="M60 32.9655H58.069V34.8966H60V32.9655Z" fill="#2A2A2A" />
        <path
          d="M13.6552 34.8966H11.7241V36.8276H13.6552V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 34.8966H15.5862V36.8276H17.5172V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 34.8966H19.4483V36.8276H21.3793V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 34.8966H21.3793V36.8276H23.3103V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 34.8966H23.3103V36.8276H25.2414V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 34.8966H25.2414V36.8276H27.1724V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 34.8966H27.1724V36.8276H29.1034V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 34.8966H29.1034V36.8276H31.0345V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 34.8966H31.0345V36.8276H32.9655V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 34.8966H34.8966V36.8276H36.8276V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 34.8966H36.8276V36.8276H38.7586V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 34.8966H38.7586V36.8276H40.6897V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 34.8966H40.6897V36.8276H42.6207V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 34.8966H42.6207V36.8276H44.5517V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 34.8966H44.5517V36.8276H46.4828V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 34.8966H46.4828V36.8276H48.4138V34.8966Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 34.8966H48.4138V36.8276H50.3448V34.8966Z"
          fill="#2A2A2A"
        />
        <path d="M60 34.8966H58.069V36.8276H60V34.8966Z" fill="#2A2A2A" />
        <path d="M5.93103 36.8276H4V38.7586H5.93103V36.8276Z" fill="#2A2A2A" />
        <path
          d="M7.86207 36.8276H5.93103V38.7586H7.86207V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M9.7931 36.8276H7.86207V38.7586H9.7931V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 36.8276H9.7931V38.7586H11.7241V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 36.8276H13.6552V38.7586H15.5862V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M19.4483 36.8276H17.5172V38.7586H19.4483V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 36.8276H19.4483V38.7586H21.3793V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 36.8276H31.0345V38.7586H32.9655V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 36.8276H34.8966V38.7586H36.8276V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 36.8276H38.7586V38.7586H40.6897V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 36.8276H44.5517V38.7586H46.4828V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 36.8276H48.4138V38.7586H50.3448V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 36.8276H50.3448V38.7586H52.2759V36.8276Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 38.7586H13.6552V40.6897H15.5862V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 38.7586H15.5862V40.6897H17.5172V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 38.7586H23.3103V40.6897H25.2414V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 38.7586H27.1724V40.6897H29.1034V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 38.7586H29.1034V40.6897H31.0345V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 38.7586H31.0345V40.6897H32.9655V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 38.7586H32.9655V40.6897H34.8966V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 38.7586H34.8966V40.6897H36.8276V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 38.7586H36.8276V40.6897H38.7586V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 38.7586H42.6207V40.6897H44.5517V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 38.7586H44.5517V40.6897H46.4828V38.7586Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 38.7586H56.1379V40.6897H58.069V38.7586Z"
          fill="#2A2A2A"
        />
        <path d="M60 38.7586H58.069V40.6897H60V38.7586Z" fill="#2A2A2A" />
        <path d="M5.93103 40.6897H4V42.6207H5.93103V40.6897Z" fill="#2A2A2A" />
        <path
          d="M9.7931 40.6897H7.86207V42.6207H9.7931V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 40.6897H25.2414V42.6207H27.1724V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 40.6897H29.1034V42.6207H31.0345V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 40.6897H31.0345V42.6207H32.9655V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 40.6897H32.9655V42.6207H34.8966V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 40.6897H34.8966V42.6207H36.8276V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 40.6897H38.7586V42.6207H40.6897V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 40.6897H42.6207V42.6207H44.5517V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 40.6897H48.4138V42.6207H50.3448V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 40.6897H50.3448V42.6207H52.2759V40.6897Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 40.6897H52.2759V42.6207H54.2069V40.6897Z"
          fill="#2A2A2A"
        />
        <path d="M5.93103 42.6207H4V44.5517H5.93103V42.6207Z" fill="#2A2A2A" />
        <path
          d="M7.86207 42.6207H5.93103V44.5517H7.86207V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M9.7931 42.6207H7.86207V44.5517H9.7931V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 42.6207H9.7931V44.5517H11.7241V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 42.6207H13.6552V44.5517H15.5862V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 42.6207H15.5862V44.5517H17.5172V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 42.6207H19.4483V44.5517H21.3793V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 42.6207H21.3793V44.5517H23.3103V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 42.6207H23.3103V44.5517H25.2414V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 42.6207H25.2414V44.5517H27.1724V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 42.6207H27.1724V44.5517H29.1034V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 42.6207H29.1034V44.5517H31.0345V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 42.6207H32.9655V44.5517H34.8966V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 42.6207H42.6207V44.5517H44.5517V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 42.6207H44.5517V44.5517H46.4828V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 42.6207H46.4828V44.5517H48.4138V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 42.6207H48.4138V44.5517H50.3448V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 42.6207H50.3448V44.5517H52.2759V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 42.6207H52.2759V44.5517H54.2069V42.6207Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 44.5517H23.3103V46.4828H25.2414V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 44.5517H27.1724V46.4828H29.1034V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 44.5517H31.0345V46.4828H32.9655V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 44.5517H32.9655V46.4828H34.8966V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 44.5517H34.8966V46.4828H36.8276V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 44.5517H36.8276V46.4828H38.7586V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 44.5517H40.6897V46.4828H42.6207V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 44.5517H42.6207V46.4828H44.5517V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 44.5517H50.3448V46.4828H52.2759V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 44.5517H54.2069V46.4828H56.1379V44.5517Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 44.5517H56.1379V46.4828H58.069V44.5517Z"
          fill="#2A2A2A"
        />
        <path d="M60 44.5517H58.069V46.4828H60V44.5517Z" fill="#2A2A2A" />
        <path d="M5.93103 46.4828H4V48.4138H5.93103V46.4828Z" fill="#2A2A2A" />
        <path
          d="M7.86207 46.4828H5.93103V48.4138H7.86207V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M9.7931 46.4828H7.86207V48.4138H9.7931V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 46.4828H9.7931V48.4138H11.7241V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 46.4828H11.7241V48.4138H13.6552V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M15.5862 46.4828H13.6552V48.4138H15.5862V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 46.4828H15.5862V48.4138H17.5172V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 46.4828H19.4483V48.4138H21.3793V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 46.4828H25.2414V48.4138H27.1724V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 46.4828H27.1724V48.4138H29.1034V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 46.4828H29.1034V48.4138H31.0345V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 46.4828H31.0345V48.4138H32.9655V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 46.4828H34.8966V48.4138H36.8276V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 46.4828H40.6897V48.4138H42.6207V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 46.4828H42.6207V48.4138H44.5517V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 46.4828H46.4828V48.4138H48.4138V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 46.4828H50.3448V48.4138H52.2759V46.4828Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 46.4828H56.1379V48.4138H58.069V46.4828Z"
          fill="#2A2A2A"
        />
        <path d="M5.93103 48.4138H4V50.3448H5.93103V48.4138Z" fill="#2A2A2A" />
        <path
          d="M17.5172 48.4138H15.5862V50.3448H17.5172V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 48.4138H19.4483V50.3448H21.3793V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 48.4138H21.3793V50.3448H23.3103V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 48.4138H23.3103V50.3448H25.2414V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 48.4138H25.2414V50.3448H27.1724V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 48.4138H42.6207V50.3448H44.5517V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 48.4138H50.3448V50.3448H52.2759V48.4138Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 48.4138H52.2759V50.3448H54.2069V48.4138Z"
          fill="#2A2A2A"
        />
        <path d="M60 48.4138H58.069V50.3448H60V48.4138Z" fill="#2A2A2A" />
        <path d="M5.93103 50.3448H4V52.2759H5.93103V50.3448Z" fill="#2A2A2A" />
        <path
          d="M9.7931 50.3448H7.86207V52.2759H9.7931V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 50.3448H9.7931V52.2759H11.7241V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 50.3448H11.7241V52.2759H13.6552V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 50.3448H15.5862V52.2759H17.5172V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 50.3448H21.3793V52.2759H23.3103V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M27.1724 50.3448H25.2414V52.2759H27.1724V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M36.8276 50.3448H34.8966V52.2759H36.8276V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M40.6897 50.3448H38.7586V52.2759H40.6897V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 50.3448H42.6207V52.2759H44.5517V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 50.3448H44.5517V52.2759H46.4828V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 50.3448H46.4828V52.2759H48.4138V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 50.3448H48.4138V52.2759H50.3448V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M52.2759 50.3448H50.3448V52.2759H52.2759V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 50.3448H52.2759V52.2759H54.2069V50.3448Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 50.3448H54.2069V52.2759H56.1379V50.3448Z"
          fill="#2A2A2A"
        />
        <path d="M60 50.3448H58.069V52.2759H60V50.3448Z" fill="#2A2A2A" />
        <path d="M5.93103 52.2759H4V54.2069H5.93103V52.2759Z" fill="#2A2A2A" />
        <path
          d="M9.7931 52.2759H7.86207V54.2069H9.7931V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 52.2759H9.7931V54.2069H11.7241V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 52.2759H11.7241V54.2069H13.6552V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 52.2759H15.5862V54.2069H17.5172V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M21.3793 52.2759H19.4483V54.2069H21.3793V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 52.2759H21.3793V54.2069H23.3103V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 52.2759H23.3103V54.2069H25.2414V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 52.2759H27.1724V54.2069H29.1034V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 52.2759H29.1034V54.2069H31.0345V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 52.2759H31.0345V54.2069H32.9655V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 52.2759H32.9655V54.2069H34.8966V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 52.2759H36.8276V54.2069H38.7586V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 52.2759H42.6207V54.2069H44.5517V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M46.4828 52.2759H44.5517V54.2069H46.4828V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 52.2759H46.4828V54.2069H48.4138V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M50.3448 52.2759H48.4138V54.2069H50.3448V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 52.2759H52.2759V54.2069H54.2069V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 52.2759H54.2069V54.2069H56.1379V52.2759Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 52.2759H56.1379V54.2069H58.069V52.2759Z"
          fill="#2A2A2A"
        />
        <path d="M60 52.2759H58.069V54.2069H60V52.2759Z" fill="#2A2A2A" />
        <path d="M5.93103 54.2069H4V56.1379H5.93103V54.2069Z" fill="#2A2A2A" />
        <path
          d="M9.7931 54.2069H7.86207V56.1379H9.7931V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M11.7241 54.2069H9.7931V56.1379H11.7241V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M13.6552 54.2069H11.7241V56.1379H13.6552V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M17.5172 54.2069H15.5862V56.1379H17.5172V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M25.2414 54.2069H23.3103V56.1379H25.2414V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M32.9655 54.2069H31.0345V56.1379H32.9655V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M38.7586 54.2069H36.8276V56.1379H38.7586V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 54.2069H42.6207V56.1379H44.5517V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M48.4138 54.2069H46.4828V56.1379H48.4138V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 54.2069H52.2759V56.1379H54.2069V54.2069Z"
          fill="#2A2A2A"
        />
        <path
          d="M58.069 54.2069H56.1379V56.1379H58.069V54.2069Z"
          fill="#2A2A2A"
        />
        <path d="M60 54.2069H58.069V56.1379H60V54.2069Z" fill="#2A2A2A" />
        <path d="M5.93103 56.1379H4V58.069H5.93103V56.1379Z" fill="#2A2A2A" />
        <path
          d="M17.5172 56.1379H15.5862V58.069H17.5172V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M23.3103 56.1379H21.3793V58.069H23.3103V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M29.1034 56.1379H27.1724V58.069H29.1034V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M31.0345 56.1379H29.1034V58.069H31.0345V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M34.8966 56.1379H32.9655V58.069H34.8966V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M42.6207 56.1379H40.6897V58.069H42.6207V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M44.5517 56.1379H42.6207V58.069H44.5517V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M54.2069 56.1379H52.2759V58.069H54.2069V56.1379Z"
          fill="#2A2A2A"
        />
        <path
          d="M56.1379 56.1379H54.2069V58.069H56.1379V56.1379Z"
          fill="#2A2A2A"
        />
        <path d="M5.93103 58.069H4V60H5.93103V58.069Z" fill="#2A2A2A" />
        <path d="M7.86207 58.069H5.93103V60H7.86207V58.069Z" fill="#2A2A2A" />
        <path d="M9.7931 58.069H7.86207V60H9.7931V58.069Z" fill="#2A2A2A" />
        <path d="M11.7241 58.069H9.7931V60H11.7241V58.069Z" fill="#2A2A2A" />
        <path d="M13.6552 58.069H11.7241V60H13.6552V58.069Z" fill="#2A2A2A" />
        <path d="M15.5862 58.069H13.6552V60H15.5862V58.069Z" fill="#2A2A2A" />
        <path d="M17.5172 58.069H15.5862V60H17.5172V58.069Z" fill="#2A2A2A" />
        <path d="M23.3103 58.069H21.3793V60H23.3103V58.069Z" fill="#2A2A2A" />
        <path d="M25.2414 58.069H23.3103V60H25.2414V58.069Z" fill="#2A2A2A" />
        <path d="M31.0345 58.069H29.1034V60H31.0345V58.069Z" fill="#2A2A2A" />
        <path d="M32.9655 58.069H31.0345V60H32.9655V58.069Z" fill="#2A2A2A" />
        <path d="M36.8276 58.069H34.8966V60H36.8276V58.069Z" fill="#2A2A2A" />
        <path d="M38.7586 58.069H36.8276V60H38.7586V58.069Z" fill="#2A2A2A" />
        <path d="M40.6897 58.069H38.7586V60H40.6897V58.069Z" fill="#2A2A2A" />
        <path d="M42.6207 58.069H40.6897V60H42.6207V58.069Z" fill="#2A2A2A" />
        <path d="M44.5517 58.069H42.6207V60H44.5517V58.069Z" fill="#2A2A2A" />
        <path d="M46.4828 58.069H44.5517V60H46.4828V58.069Z" fill="#2A2A2A" />
        <path d="M48.4138 58.069H46.4828V60H48.4138V58.069Z" fill="#2A2A2A" />
        <path d="M50.3448 58.069H48.4138V60H50.3448V58.069Z" fill="#2A2A2A" />
        <path d="M56.1379 58.069H54.2069V60H56.1379V58.069Z" fill="#2A2A2A" />
        <path d="M60 58.069H58.069V60H60V58.069Z" fill="#2A2A2A" />
      </g>
      <defs>
        <clipPath id="clip0_40008726_10210">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SaveIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="4" fill="#52CBC4" />
      <path
        d="M12.1667 25.5H23.8333C24.7538 25.5 25.5 24.7538 25.5 23.8333V15.357C25.5 14.915 25.3244 14.4911 25.0118 14.1785L21.8215 10.9882C21.5089 10.6756 21.085 10.5 20.643 10.5H12.1667C11.2462 10.5 10.5 11.2462 10.5 12.1667V23.8333C10.5 24.7538 11.2462 25.5 12.1667 25.5Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 10.5V14.6667H20.4997V10.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 25.5V20.5H22.1663V25.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="35" height="35" rx="3.5" stroke="#EBEBEB" />
      <path
        d="M13 23L23 13M13 13L23 23"
        stroke="#606060"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


export const EditIcon = () => {
  return (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0514 5.73889L17.4576 4.33265C18.0678 3.72245 19.0572 3.72245 19.6674 4.33265C20.2775 4.94284 20.2775 5.93216 19.6674 6.54235L10.8185 15.3912C10.3779 15.8318 9.83453 16.1556 9.23741 16.3335L7 17L7.66648 14.7626C7.84435 14.1655 8.1682 13.6221 8.60877 13.1815L16.0514 5.73889ZM16.0514 5.73889L18.25 7.93749M17 13.6667V17.625C17 18.6605 16.1605 19.5 15.125 19.5H6.375C5.33947 19.5 4.5 18.6605 4.5 17.625V8.87499C4.5 7.83946 5.33947 6.99999 6.375 6.99999H10.3333" stroke="#606060" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


  );
}

export const DeleteIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.33398 7.14706H18.6673M10.334 15.9706V10.6765M13.6673 15.9706V10.6765M15.334 19.5H8.66732C7.74684 19.5 7.00065 18.7099 7.00065 17.7353V8.02941C7.00065 7.5421 7.37375 7.14706 7.83398 7.14706H16.1673C16.6276 7.14706 17.0007 7.5421 17.0007 8.02941V17.7353C17.0007 18.7099 16.2545 19.5 15.334 19.5ZM10.334 7.14706H13.6673C14.1276 7.14706 14.5007 6.75202 14.5007 6.26471V5.38235C14.5007 4.89504 14.1276 4.5 13.6673 4.5H10.334C9.87375 4.5 9.50065 4.89504 9.50065 5.38235V6.26471C9.50065 6.75202 9.87375 7.14706 10.334 7.14706Z" stroke="#FF5757" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  );
}